import Chart from './Chart/Chart';

export default Chart;
